export const environment = {
  production: true,
  disabledProducts: ['audyty'],
  imagesUrl: '',
  sentry: 'https://3a6356faed784dd68f58ce8acc85a100@o375550.ingest.sentry.io/5195187',
  // Baza URL zl-backendu (aktualnosci); pusty = dev-proxy /zl-api.
  contentApiUrl: 'https://api.zatrzymajlicznik.pl'
};
